// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".img[data-v-e7a3a2a2] {\n  max-height: 80px;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
